import { downloadFile } from './exportExcel';
import { isWindowsSystem } from './ua';
export async function exportCsv(data, config) {
    const { unparse } = await import('papaparse');
    let text = unparse(data, config);
    if (isWindowsSystem()) { // 加bom头 在windows系统下，避免中文乱码
        text = `\uFEFF${text}`;
    }
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    downloadFile(config.fileName, blob);
}
